import axiosInstance, { endpoints } from 'src/utils/axios';

import { createListHook, createObjectHook } from './utils/create-action';

// ----------------------------------------------------------------------

// Organization types - returns array
export const useGetOrgTypes = createObjectHook(endpoints.org.types);

// Organization companies - returns list with count
export const useGetOrgCompanies = createListHook(endpoints.org.companies);

// Organization managers - returns list with count
export const useGetOrgManagers = createListHook(endpoints.org.managers);

// Organization brands - returns list with count
export const useGetOrgBrands = createListHook(endpoints.org.brands);

// Assign organization type
export function assignOrgType(orgType, orgGroup) {
    const url = `${endpoints.org.types}/${orgType}`;
    return axiosInstance.post(url, { name: orgGroup });
}
